import React from 'react';
// model && interfaces
import Data from '../../../../model/Data';
import VacancyInterface from '../../../../model/Vacancy';
// common components
import VacancyPlate from '../../../../common/components/VacancyPlate/VacancyPlate';
import Grid from '../../../../common/components/Grid/Grid';
// styles
import './VacanciesList.css';

interface Props {
  className?: string;
}

class VacanciesList extends React.Component<Props> {
  
  vacancyItem(vacancy: VacancyInterface): JSX.Element {
    return (
      <div className={Grid.itemClass(4)}>
        <VacancyPlate vacancy={vacancy} key={`vacancy-${vacancy.id}`} />
      </div>
    )
  }
  
  render(): JSX.Element {
    const vacancies = Data.Instance.vacanciesReferal();
    
    return (
      <div className="vacancies-list" id="vacancies-list">
        <div className="vacancies-list-inner container">
          <h1 className="vacancies-list-title bold">Список вакансий:</h1>
          <Grid className="vacancies">
            { vacancies.map((v) => this.vacancyItem(v)) }
          </Grid>
        </div>
      </div>
    );
  }
}

export default VacanciesList;
